import styled from "styled-components";

export const YoutubeLiveWrapper = styled.div`
  position: fixed;
  bottom: 105px;
  right: 16px;
  z-index: 1000;
`;

export const YoutubeLiveButton = styled.div`
  width: 50px;

  > img {
    width: 50px;
  }
`;

export const YouTubeLiveListWrapper = styled.div<{ listOpen: boolean }>`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 8px;
  position: absolute;
  bottom: 68px;
  left: 5px;
  opacity: ${(p) => (p.listOpen ? 1 : 0)};
  transform: ${(p) => (p.listOpen ? "translateY(0)" : "translateY(20px)")};
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
`;

export const YoutubeLiveItem = styled.div`
  border: 2px solid #ff0004;
  width: 39px;
  height: 39px;
  border-radius: 50%;
  position: relative;
  background: #fff;

  > .title {
    position: absolute;
    width: 25px;
    height: 14px;
    bottom: -5px;
    left: 5px;
    border-radius: 50px;
    background: #ff0004;
    font-weight: 600;
    font-size: 8px;
    line-height: 14px;
    text-align: center;
    color: #fff;
  }

  > img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
  }
`;
